import axios from 'axios'
import { BUSCAR_PRECOS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarPrecos (codigo, filtrosAdicionados, pagina, registrosPorPagina) {
  pagina = pagina?pagina: 1
  registrosPorPagina = registrosPorPagina? registrosPorPagina : 10
  let urlBase = `${URL}/preco/empresa/${codigo}/precos?size=${registrosPorPagina}&from=${pagina}`;
  
  if (filtrosAdicionados) {
    if (filtrosAdicionados.origem) {
      urlBase = `${urlBase}&origem=${filtrosAdicionados.origem.id}`
    }

    if (filtrosAdicionados.destino) {
      urlBase = `${urlBase}&destino=${filtrosAdicionados.destino.id}`
    }

    if (filtrosAdicionados.tipoPreco) {
      urlBase = `${urlBase}&tipoPreco=${filtrosAdicionados.tipoPreco}`
    }
  }

  return dispatch => axios.get(urlBase, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: BUSCAR_PRECOS,
      payload: {
        precoPaginacao: response.data
      }
    })
  )
}
